export default {
  sign_in_title: "Connectez-vous à votre compte",
  sign_up_title: "Créez un nouveau compte",
  email: "Adresse email",
  email_required: "Veuillez saisir votre adresse email",
  email_placeholder: "votre{0}exemple.com",
  email_invalid: "Veuillez saisir une adresse email valide",
  password: "Mot de passe",
  password_placeholder: "Saisissez votre mot de passe",
  password_required: "Veuillez saisir votre mot de passe",
  password_invalid:
    "Le mot de passe doit comporter au moins 8 caractères et contenir des lettres, des chiffres et des caractères spéciaux",
  forgot_password: "Mot de passe oublié ?",
  confirm_password_required: "Veuillez confirmer votre mot de passe",
  confirm_password_placeholder: "Confirmez le mot de passe",
  passwords_do_not_match: "Les deux mots de passe saisis ne correspondent pas",
  or: "Ou",
  no_account: "Vous n'avez pas de compte ?",
  have_account: "Vous avez déjà un compte ?",
  error: "Échec de la connexion. Veuillez vérifier votre email et votre mot de passe.",
  google_error: "Échec de la connexion Google",
  x_error: "Échec de la connexion X",
  linkedin_error: "Échec de la connexion LinkedIn",
  google_sign_in: "Se connecter avec Google",
  google_sign_up: "S'inscrire avec Google",
  apple_sign_in: "Se connecter avec Apple",
  apple_sign_up: "S'inscrire avec Apple",
  twitter_sign_in: "Se connecter avec X",
  twitter_sign_up: "S'inscrire avec X",
  linkedin_sign_in: "Se connecter avec LinkedIn",
  linkedin_sign_up: "S'inscrire avec LinkedIn",
  aria_card: "Carte de connexion",
  aria_email: "Champ de saisie de l'email",
  aria_password: "Champ de saisie du mot de passe",
  aria_submit: "Bouton de soumission",
  aria_google: "Bouton de connexion avec Google",
  aria_linkedin: "Bouton de connexion avec LinkedIn",
  aria_switch_mode: "Basculer entre Connexion/Inscription",
  welcome: "Bienvenue sur TaxEcoBit",
  subtitle: "Plateforme de calcul de taxe carbone conforme au CBAM de l'UE",
  benefit1: "Calcul précis de la taxe carbone avec moins de 10 % d'erreur",
  benefit2: "Prend en charge plusieurs modes de transport et facteurs personnalisés",
  benefit3: "Prise en charge de l'intégration API",
  benefit4: "Génère des rapports conformes répondant aux exigences du CBAM de l'UE",
  user_friendly: "Convivial",
  secure_reliable: "Sécurisé et fiable",
  cloud_sync: "Synchronisation cloud",
  invite_code: "Code d'invitation",
  invite_code_placeholder: "Veuillez saisir le code d'invitation (facultatif)",
  invite_code_detected: "Code d'invitation détecté",
  invited_by_user: "Invité par",
  sign_out: "Se déconnecter",
  agreement_prefix: "En vous inscrivant à TaxEcoBit, vous acceptez nos",
  terms: "Conditions d'utilisation",
  and: "et",
  privacy: "Politique de confidentialité",
  agreement_required: "Veuillez d'abord accepter la politique de confidentialité",
  complete_verification: "Veuillez d'abord terminer la vérification",
  loading_verification: "Chargement de la vérification...",
  verification_failed: "Échec de la vérification, veuillez réessayer",
};
